import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const FETCH_LEADS_TRANSACTIONS_REQUEST = 'app/ProviderLeadsCalendarPage/FETCH_LEADS_TRANSACTIONS_REQUEST';
export const FETCH_LEADS_TRANSACTIONS_SUCCESS = 'app/ProviderLeadsCalendarPage/FETCH_LEADS_TRANSACTIONS_SUCCESS';
export const FETCH_LEADS_TRANSACTIONS_ERROR = 'app/ProviderLeadsCalendarPage/FETCH_LEADS_TRANSACTIONS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchLeadsInProgress: false,
  fetchLeadsError: null,
  
  // Data
  transactions: [],
  pagination: null,
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
};

export default function providerLeadsCalendarPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  
  switch (type) {
    case FETCH_LEADS_TRANSACTIONS_REQUEST:
      return { ...state, fetchLeadsInProgress: true, fetchLeadsError: null };
    case FETCH_LEADS_TRANSACTIONS_SUCCESS:
      const { entities, meta } = payload;
      return {
        ...state,
        fetchLeadsInProgress: false,
        transactions: entities || [],
        pagination: meta || null,
        totalItems: meta?.totalItems || 0,
        totalPages: meta?.totalPages || 0,
        currentPage: meta?.page || 1,
      };
    case FETCH_LEADS_TRANSACTIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchLeadsInProgress: false, fetchLeadsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchLeadsTransactionsRequest = () => ({ type: FETCH_LEADS_TRANSACTIONS_REQUEST });
const fetchLeadsTransactionsSuccess = response => ({
  type: FETCH_LEADS_TRANSACTIONS_SUCCESS,
  payload: response,
});
const fetchLeadsTransactionsError = e => ({
  type: FETCH_LEADS_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const PAGE_SIZE = 100; // Larger page size for calendar view

export const fetchLeadsTransactions = (params = {}) => (dispatch, getState, sdk) => {
  dispatch(fetchLeadsTransactionsRequest());
  
  const { currentUser } = getState().user;
  
  if (!currentUser) {
    const error = new Error('User not authenticated');
    dispatch(fetchLeadsTransactionsError(storableError(error)));
    return Promise.reject(error);
  }

  // Query parameters for fetching transactions where current user is the provider
  const queryParams = {
    only: 'sale', // 'sale' means current user is the provider
    include: ['customer', 'provider', 'listing', 'booking'],
    'fields.transaction': [
      'id',
      'createdAt',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'processName',
      'processVersion',
      'protectedData.leadStart',
      'protectedData.leadEnd',
      'protectedData.notes',
    ],
    'fields.user': ['id', 'profile'],
    'fields.listing': ['id', 'title'],
    processNames: 'request-lead', // Use processNames (plural) not processName
    perPage: PAGE_SIZE,
    ...params
  };

  return sdk.transactions
    .query(queryParams)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      const meta = response.data.meta;
      
      dispatch(fetchLeadsTransactionsSuccess({
        entities,
        meta
      }));
      return response;
    })
    .catch(e => {
      dispatch(fetchLeadsTransactionsError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search) => dispatch => {
  const queryParams = parse(search);
  return dispatch(fetchLeadsTransactions({ ...params, ...queryParams }));
};